export default __webpack_public_path__ + "static/media/solace-logo-white.8dd51d5b.svg";